import moment from 'moment';
import { useTranslation } from 'react-i18next';

import { Button } from '../button';
import { ButtonContainer } from '../styled';
import { Header } from '../../styled';
import { CommentsContent, CommentsBlock, Comment } from './comments.styled';

export const Comments = ({ removeFormInfo, comments, style }) => {
  const { t } = useTranslation();

  const getItemsEl = () => {
    return comments.map((el, idx) => {
      const d = moment(el.created_at).format('lll');
      return (
        <Comment key={idx}>
          <td>{d}</td>
          <td>{el.user_name}</td>
          <td title={el.comment}>
            <div>{el.comment}</div>
          </td>
        </Comment>
      );
    });
  };

  const close = () => {
    removeFormInfo();
  };

  if (!comments) {
    return null;
  }

  const cancelClick = (event) => {
    event.stopPropagation();
  };

  const itemsEl = comments.length ? getItemsEl() : null;

  return (
    <CommentsContent onClick={cancelClick} style={style}>
      <Header>{t('grid.Комментарии')}</Header>
      <CommentsBlock>
        {comments.length > 0 ? (
          <table width="100%">
            <thead>
              <tr>
                <th width="155">{t('form.Дата')}</th>
                <th width="120">{t('grid.Автор')}</th>
                <th>{t('filter.Текст')}</th>
              </tr>
            </thead>
            <tbody>{itemsEl}</tbody>
          </table>
        ) : (
          <p>{t('filter.Комментарии отсутствуют')}</p>
        )}
      </CommentsBlock>
      <ButtonContainer space="20px" justifyContent="flex-end">
        <Button onClick={close}>{t('buttons.Ок')}</Button>
      </ButtonContainer>
    </CommentsContent>
  );
};
